(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .controller("PricingController", pricingController);

  /** @ngInject */
  function pricingController($scope, userActions, pricingActions, $log) {
    var vm = this;

    vm.refreshTokenPackageList = function () {
      refreshTokenPackages();
    };

    vm.refreshSingleWashList = function() {
      refreshSingleWashes();
    }

    // vm.refreshSavingsPackageList = function () {
    //   refreshSavingsPackages();
    // };

    function refresh() {
      refreshTokenPackages();
      refreshSingleWashes();
      //refreshSavingsPackages();
    }

    function refreshTokenPackages() {
      pricingActions.getCompanyTokenPackage().then(
          function (data) {
            vm.tokenPackagesData = data;
          },
          function (errorData) {
            $log.log("An error occured" + errorData);
          }
      );
    }

    function refreshSingleWashes() {
      pricingActions.getSingeWashes().then(
          function (data) {
            vm.singleWashData = data;
          },
          function (errorData) {
            $log.log("An error occured" + errorData);
          }
      );
    }

    // function refreshSavingsPackages() {
    //   pricingActions.getCompanySavingsPackages().then(
    //       function (data) {
    //         vm.savingsPackagesData = data;
    //       },
    //       function (errorData) {
    //         $log.log("An error occured" + errorData);
    //       }
    //   );
    // }

    init();

    function init() {
      // This two calls were nested only to get currency for users region. Badly done, need to be fix (backend issue)
      userActions.getCompanyDetails().then(function (res) {
        userActions.getRegionById(res.regionId).then(function (response) {
          vm.regionCurrency = response.currencyCode;
        });
      });
      refresh();
      $scope.$on("$destroy", destroy);
    }

    function destroy() {}
  }
})();
